/**
 * Constants for Task Manager V2
 */

export const PAGE_SIZES = [10, 20, 30, 40, 50, 100] as const;

export const DEFAULT_PAGE_SIZE = PAGE_SIZES[0];

// Maximum number of tasks to fetch in a single request
export const MAX_TASKS_PER_REQUEST = 10000;

// Tab configuration for status filters
export interface StatusTabConfig {
  key: string;
  label: string;
  status: "not-started" | "in-progress" | "completed" | null;
  icon: string;
  activeColor: string;
  inactiveColor: string;
  chip: string;
  chipActive: string;
  iconColor: string;
}

export const STATUS_TABS: StatusTabConfig[] = [
  {
    key: "all",
    label: "All",
    status: null,
    icon: "fa-layer-group",
    activeColor: "text-slate-900 border-slate-900",
    inactiveColor: "text-slate-600 border-transparent hover:text-slate-800 hover:border-slate-300",
    chip: "border-slate-300 text-slate-700",
    chipActive: "border-slate-900 text-slate-900",
    iconColor: "text-slate-500",
  },
  {
    key: "in_progress",
    label: "In Progress",
    status: "in-progress",
    icon: "fa-spinner",
    activeColor: "text-amber-800 border-amber-600",
    inactiveColor: "text-slate-600 border-transparent hover:text-amber-700 hover:border-amber-200",
    chip: "border-amber-200 text-amber-700",
    chipActive: "border-amber-600 text-amber-800",
    iconColor: "text-amber-500",
  },
  {
    key: "completed",
    label: "Completed",
    status: "completed",
    icon: "fa-circle-check",
    activeColor: "text-emerald-800 border-emerald-600",
    inactiveColor: "text-slate-600 border-transparent hover:text-emerald-700 hover:border-emerald-200",
    chip: "border-emerald-200 text-emerald-700",
    chipActive: "border-emerald-600 text-emerald-800",
    iconColor: "text-emerald-500",
  },
  {
    key: "not_started",
    label: "Not Started",
    status: "not-started",
    icon: "fa-hourglass-start",
    activeColor: "text-slate-900 border-slate-900",
    inactiveColor: "text-slate-600 border-transparent hover:text-slate-800 hover:border-slate-300",
    chip: "border-slate-300 text-slate-700",
    chipActive: "border-slate-900 text-slate-900",
    iconColor: "text-slate-500",
  },
];

export const GRID_CONFIG = {
  HEADER_HEIGHT: 48,
  ROW_HEIGHT: 72,
  PADDING: 20,
  PAGINATION_HEIGHT: 60,
  MAX_VISIBLE_HEIGHT: 600, // Maximum height for grid container to enable virtualization
} as const;

// Debounce delay for filter changes (ms)
export const FILTER_DEBOUNCE_DELAY = 300;


